// R1 (ARCFE-985): the read half of the `workspaceIdAtom` row retirement —
// components read the active workspace id through this hook; writes go
// through the `setWorkspaceId` command; derivations through
// `workspaceIdReadAtom`; non-React code through `getWorkspaceId()`.
import { useAtomValue } from 'jotai';

import { workspaceIdAtom } from '../atoms/workspaceAtoms';

export function useWorkspaceId(): string | null {
  return useAtomValue(workspaceIdAtom);
}
